import { createRouter, createWebHistory } from 'vue-router';
import { ProfileRoutes } from '@/features/profiles/routes';
import { ProfileBlacklistRoutes } from '@/features/profileBlacklist/routes';
import { ProfileWhitelistRoutes } from '@/features/profileWhitelist/routes';
import { IssueFormMetadataRoutes } from '@/features/issueFormMetadata/routes';
import AccessDenied from '@/features/shared/AccessDenied.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...ProfileRoutes,
        ...ProfileBlacklistRoutes,
        ...ProfileWhitelistRoutes,
        ...IssueFormMetadataRoutes,
        {
            path: '/accessdenied',
            name: 'AccessDenied',
            component: AccessDenied
        }
    ]
});

export default router;
